module.exports = __webpack_public_path__ + "media/audio38.6b9682a4.mp3";